export const ENGLISH = {
  link: {
    login: "/login",
    register: "/register",
    about: "/about",
    search: "/search",
    contact: "/contact",
    website: "/website",
    categories: "/categories",
    categorySelected: "/categories/:name",
    offers: "/offers",
    legal: "/legal",
    terms: "/terms_of_use",
    privacy: "/privacy",
    faq: "/faq",
    orderSummary: "/order_summary",
    payementConfirmation: "/payment_confirmation",
    payementCancel: "/payment_error",

    account: "/my_account",
    addCompany: "/my_account/add_company",

    manageCompany: "/my_account/manage_company/:id/",
    updateCompany: "/my_account/manage_company/:id/update",
    addWebsite: "/my_account/manage_company/:id/add_website",
    selectOffer: "/my_account/manage_company/:id/select_offers",
    manageOffer: "/my_account/manage_company/:id/manage_offers",

    manageWebsite: "/my_account/manage_website/:id/",
    updateWebsite: "/my_account/manage_website/:id/update",

    addPages: "/my_account/manage_website/:id/add_page",
    updatePage: "/my_account/manage_website/:id/update_page/:pageId/",

    admin: "/admin",
  },

  header: {
    home: "Home",
    categories: "Categories",
    about: "About us",
    offers: "Our offers",
    dashboard: "Dashboard",
    connection: "Log in",
    join: "Join",
  },

  home: {
    banner: {
      title:
        "We help your business to get a better visibility and stay connected",
      subtitle: "Register your businesses to improve your visibility online!",
    },
  },

  highLighted: {
    title: { text: "Highlighted ", strong: "websites" },
  },

  joinedBusiness: {
    title: { text: "Joined", strong: "business" },
  },

  sectionCategories: {
    title: { text: "Categories of", strong: "website" },
  },

  sectionWhy: {
    title: { text: "Why ", strong: "joining 1 Top Search?" },
    img: {
      view: "Increasing views",
      seo: "SEO increased",
      joined: "Joined websites",
    },
  },

  sectionOffer: {
    title: { text: "Our ", strong: "offers" },
  },

  search: {
    title: { text: "Search any", strong: "website" },
    labelCompany: "COMPANY",
    labelCategory: "CATEGORY",
    labelWhere: "WHERE",
    allCategories: "All categories",
    noResult: "Oups, we didn't find any website for your search...",
  },

  categories: {
    categoriesList: { single: "Category", multiple: "Categories" },
    lastWebsites: { text: "Last", strong: "websites" },
    JoinUsBlock: {
      title: "You are not registered yet? Join us!",
      subtitle:
        "Register your company and your website to increase your visibility online.",
    },
    noResult: "We didn't find any website for this category.",
  },

  login: {
    title: "Log in",
    subtitle:
      "This account is personal and private and allows you to manage directly your account, your companies and website.",
  },

  register: {
    title: "Register",
    subtitle: "Create an account and get started.",
    alreadyMember: "Already a member of 1 Top Search?",
  },

  account: {
    title: "Account",
    companies: {
      total: { single: " Company", multiple: " Companies" },
      btns: {
        add: "Add a company",
      },
      noCompanies: "No company added yet.",
    },

    manageAccount: {
      title: "Manage my account",
      name: "Name: ",
      email: "Email: ",
      role: "Role: ",
      btns: {
        edit: "Edit my info",
      },
    },

    helps: {
      title: "Need some help?",
      text: "Do you have any problem with your account? Do you need some help? Contact us for more info.",
    },
  },

  footer: {
    legal: "Legal",
    terms: "Terms & Conditions",
    privacy: "Privacy",
    faq: "FAQ",
  },

  pageLoader: "Page loading... Please wait.",

  websiteCard: {
    new: "New",
    top: "Top",
    websiteOfTheDay: "Website of the day",
  },

  categoryCard: {
    site: "Website",
    sites: "Websites",
  },

  helperBoxes: {
    why: "Why register on 1 Top Search?",
    about: "About 1 Top Search?",
    question: "Any question? Contact us!",
  },

  searchPage: {
    noResult: "Oups, we didn't find any website for your search...",
    result: "Results for",
    all: { text: "All", strong: "websites" },
    btnAdd: "Add a website",
    found: "professionals found",
  },

  seeAlso: {
    noResult: "There is no other website for the same category.",
  },

  contactPage: {
    title: "Contact",
    subtitle:
      "You can send us any request here. Please write your message below.",
    thanks: "Thank you for your message",
    getBack: "We will get back to you shortly.",
  },

  placeHolder: {
    email: "Email",
    firstName: "First name",
    lastName: "Last name",
    subject: "Subject",
    message: "Message...",
    password: "Password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    country: "Country - e.g: France",
    city: "City - e.g: Paris",
    street: "Street - e.g: 1 bis chemin du prevert.",
    codePost: "Post code - e.g: 75001",
    companyName: "Company name - e.g: Google",
    companyCode: "Company code - e.g: 877554",
    taxeNumber: "Taxe Number code - e.g:  12345678A",
    websiteName: "Name - e.g: Google", // new
    host: "Host - e.g: google.com", // new
    description: "Description...", // new,
    pageName: "Page name - e.g: About", // new
    path: "Path - e.g: www.mywebsite.com/about", // new
    selectCategories: "Select categories",
    selectLang: "Select language",
    searchName: "e.g: Google",
    searchCategory: "e.g: Digital Agency",
    searchWhere: "e.g: London",
    userEmail: "User email",
  },

  editInfo: {
    title: "Edit info",
    succes: "Success!",
  },

  forgotPassword: {
    title: "Forgot password",
    subtitle: "Please enter your email address here",
    sent: "An email has been sent",
    checkYourMail: "Please check your mailbox",
  },

  manageCompany: {
    title: "Manage company",
    Company: "Company",
    address: "Address",
    companyCode: "Company Code",
    vat: "N° VAT",
    companyWebsite: "Company websites",
    noWebsite: "No website added.",
    addWebsite: "Add website",
    totalWebsites: "Total websites",
    totalPages: "Total pages",
    status: "Status",

    companyPacks: {
      title: "Company packs",
      offerStart: "Offer started",
      offerEnd: "Offer ending",
      totalWebsites: "Total websites",
      totalPages: "Total pages",
    },
  },

  manageWebsite: {
    title: "Manage website",
    websitePages: "Website pages",
    noPages: "No pages added.",
    lang: "Lang",
    addPage: "Add page",
    description: "Description",
  },

  addCompany: {
    title: "Add company",
    subtitle: "Please fill in all the fields below to add a new company.",
    logoPreview: "Logo preview",
    addLogo: "Add logo:",
    btnAdd: "Add company",
    missingLogo: "Missing company logo.",
  },

  addWebsite: {
    title: "Add website",
    subtitle: "Please fill in all the fields below to add a new website.",
    category: "Select categories",
    language: "Select language",
    addImage: "Add image:",
    imagePreview: "Image preview",
  },

  addPage: {
    title: "Add page",
    subtitle: "Please fill in all the fields below to add a new page.",
    addImage: "Add image:",
    imagePreview: "Image preview",
  },

  updateCompany: {
    title: "Update company",
    subtitle: "Please change the fields below to update the company.",
  },

  updateWebsite: {
    title: "Update website",
    subtitle: "Please change the fields below to update the website.",
  },

  updatePage: {
    title: "Update page",
    subtitle: "Please change the fields below to update the page.",
  },

  resetPassword: {
    title: "Reset password",
    subtitle: "Please enter your new password and confirm.",
  },

  error: {
    general: "Oups, something went wrong. Please, try again.",
    missingField: "Missing field. Please fill in all the field.",
    passwordOrEmail: "Password or email incorrect.",
    invalidEmail: "Invalid email.",
    passwordConfirmation: "Password are not the same.",
    emailAlreadyRegistered: "Email already used.",
    userNotFound: "User not found.", //new
    websiteCredit:
      "Sorry, you cannot add a new website with your current company offer. You can manage the offer in order to proceed.",
    pageCredit:
      "Sorry, you cannot add a new pages with your current company offer. You can manage the offer in order to proceed.",
    userAlreadyAdded: "User already added.",
  },

  btn: {
    reset: "Reset",
    login: "Log in",
    signUp: "Sign up",
    forgotPassword: "Forgot password",
    logOut: "Log out",
    register: "Register",
    viewAll: "View all",
    learnMore: "Learn more",
    search: "Search",
    registerMyBusiness: "Register My Business",
    registerNow: "Register now",
    notMember: "Not a member yet?",
    update: "Update",
    cancel: "Cancel",
    send: "Send",
    back: "Back",
    delete: "Delete",
    edit: "Edit",
    contactUs: "Contact us",
    about: "About",
    visitWebsite: "Visit website",
    visit: "Visit",
    close: "Close",
    confirm: "Confirm",
    seeAllCategories: "See all categories",
    addWebsite: "Add website",
    addPage: "Add page",
    addCompany: "Add company",
    selectOffer: "Select the offer",
    manageOffer: "Manage offers",
    invoice: "See invoices",
    deactivate: "Deactivate",
    addOffer: "Add offer",
    unsuscribe: "Unsuscribe",
    activate: "Activate",
    seeMore: "See more",
    addUser: "Add user",
  },

  personalizedOffer: {
    plan: "Personalized offers",
    title: "MORE OPTIONS",
    first: "per website for a year",
    second: "per 10 added pages for a year",
  },

  offerCard: {
    yearly: "Yearly",
  },

  orderSummary: {
    title: "Summary of your order",
    orderTitle: "Your order",
    recapTitle: "Recap of your order",
    footer:
      "Offer conditions : the offer is available for a duration of 1 year for one company only. All the additional options are not included and should be added to your account",
    menu: {
      offer: "Offer / Options",
      details: "Details",
      quantity: "Quantity",
      price: "Price",
    },
    recap: {
      total: "Total",
      tax: "Tax included",
    },
  },

  paymentConfirmation: {
    title: "Your payment has been done!",
    subtitle: "You can enjoy your offer now.",
    btn: "Back to my account",
  },

  paymentError: {
    title: "Oh no! Something went wrong!",
    subtitle: "Please try again later...",
    btn: "Back to my account",
  },

  about: {
    first: {
      title: "About 1 Top Search",
      subtitle: "1 Top Search, the directory of professionals' websites",
      content:
        "<p>We are a directory that references many professional websites in different sectors. The aim of this directory is double. On the one hand, it allows people to find a lot of professionals in any type of categories. Thanks to a performing search browser, the users can find easily what they are looking for. On the other hand, for professionals, we help your business to get more visibility online. We suggest you different offers, different Packs to subscribe in order to answer to your professionals needs. <br> <br> <br> Besides, our motto is to control all the information published on our directory to always offer you the best quality. That is why some information (company data, website url...) is subject to control. We work to moderate the information received thanks to performing tools.<br><br><br> All content that is not professional should not appear on this professional directory.<br><br><br>The directory is composed of several sectors of activity. You can search on our database using the internal search engine. This engine works by significant keywords. Each keyword must be at least two letters apart. Our tool searches the list of keywords associated with the records referenced on 1 Top Search. The result provided is displayed in relation to the chosen sorting, by the most recent publication date.<br> <br> <br> For the professionals registered on our website, the more complete your Business Card is, the more keywords it will be associated with. It will thus have a greater potential for visibility.<br> <br> <br> You can directly manage your companies and websites from your account and dashboard. A user can have several companies and a company can have many websites. You can also add some specific pages of your website to increase your visibility and SEO</p>",
    },

    second: {
      title: "Why joining 1 Top Search?",
      content:
        "<p>For every professional who has a website, 1 Top Search is a solution that will increase your visibility online. We all know now the importance of being online. If you register your company and your website on our professional directory, you will be more visible on the web, which means that you will meet potential new customers and grow your business online.<br> <br> <br>Moreover, having your company and your website on 1 Top Search increase you natural referencing (SEO) to improve your position in the search engine thanks to keywords. So, if your website is well positioned on Google for example, thanks to a good SEO, the traffic on your website will also increase and you could get new customers. This is a very good opportunity for your business that can help your e-reputation to grow <br> <br> <br> Our main goal is to offer a better visibility online to professional from different sectors such as technology, marketing and communication or hotel and restaurants. In the meantime, user could find professional by theme but also by country. As a professional, you have several information to fill in your business card. The more information you have about your business, the more visible you will be on our directory and on the web in general. You can edit your information at any time in your user account.<br> <br> <br> Also, you can choose the offer that correspond to your needs. If you have several websites and you want to promote all,this is possible. You have different options and offers that allow you to put as many as companies, websites and pages as you want.To sum up, our directory is made to improve your visibility online by driving more traffic to your website and promoting your activity.</p>",
    },
  },

  breadcrumb: {
    account: "Account",
    manageCompany: "Manage company",
    manageWebsite: "Manage website",
  },

  websiteShow: {
    title: "Website",
    noPage: "This website didn't add any pages yet.",
  },

  ManageOfferModal: {
    websiteTitle:
      "Oups, it seems that your current offer does not allow you to add a new website",
    pageTitle:
      "Oups, it seems that your current offer does not allow you to add a new page",
    subtitle: "You can manage your company offer in order to proceed.",
  },

  selectOffer: {
    personalizedOffers: "Personalized offers",
  },

  companyWebsiteCard: {
    page: "Page",
  },

  manageOffer: {
    title: "Manage offer",
    title2: "Actual suscriptions",
    modal: {
      title: "Unsubscribe",
      title2: "Are you sure you want to unsubscribe?",
      subtitle:
        "You are going to be unsuscribed but the offer is still valid and will end the ",
      subtitle2: "Please wait...",
      wait: "Please wait.",
    },
  },

  status: {
    validated: "Validated",
    pending: "Pending",
    pendingFast: "Pending fast",
    denied: "Denied",
    deactivated: "Deactivated",
    deleted: "Deleted",
    unknow: "Unknow",
  },

  invoices: {
    title: "Company invoices",
    chekInvoice: "Check invoice",
    noInvoices: "No invoices found",
    date: "Date:",
  },

  faq: {
    title: "Frequently Asked Questions",
    first: {
      title: "GENERAL",
      content:
        "<p class='faq__bloc-title'>What is 1 Top Search?</p><br/><p>1 Top Search is a professional directory whose goal is double. On the one hand, it enables users ro find directly professionals from many different activity sectors that can be health, electronics, building, restaurants, technology and so on, by searching on our website thanks to a performing tools. On the other hand, it enables professionals from any sectors to register their company and their website, evene specific web pages to increase their visibility online.</p><br/><br/><p class='faq__bloc-title' > Can we register for free?<p/><br/><p>All professionals can subscribe for free by creating a user account with full name, email adress and password. The free subscription allows you to register your business (one company), your website (one website) and one dedicated web page.</p>",
    },
    second: {
      title: "OFFER",
      content:
        "<p class='faq__bloc-title'>What are the offers? What are the benefits? </p> <br/> <p>We have several offers that allow you to be more visible online according to your needs. Each offer is linked to a company. A company can suscribe to different offers.<br/><br/> - With the Pack Company simple you can add (in addition to the free registration) 1 website and 10 dedicated pages. This offer enable to increase your referencing on serch engine (SEO).<br/><br/> - With the Pack Agency you can add (in addition to the free registration) 10 websites and 10 dedicated pages more per website. If you are an agency or you work with several companies that want to get more visibility online, it can be a huge advantage. If you want to add more website or pages in addition to your offer, you can do it thanks to the personalized options.</p><br/><br/><p class='faq__bloc-title'>How long is the offer valid? Is there a commitment period? Can I cancel the offer at any time? </p><br/> <p>Each offer is valid for a period of one year. and is renewed tacitly if you do not unsubscribe. You can unsubscribe from the offer at any time from your user area. The offer will remain valid until its expiry date. The end of your offer will result in the suspension of your sites and pages, if applicable.</p>",
    },
    third: {
      title: "PAYMENT",
      content:
        "<p class='faq__bloc-title'>How I can pay?</p> <br/> <p>You can pay by credit card (Credit Card, Visa, Eurocard/Mastercard, American express) or by Paypal directly on our website <a>www.1top-search.com.</a> </p><br/><br/><p class='faq__bloc-title'>Is the payment secure? </p><br/> <p>Payment by credit card is completely secure. Your card numbers are transmitted to our secure server using the SSL encrypted protocol. When paying by credit card, this system automatically checks the validity of access rights. It encrypts all our exchanges, guaranteeing their confidentiality. Your credit card numbers are never in the possession of 1 Top Search, they are entered on our bank's secure server.</p>",
    },
    fourth: {
      title: "PERSONAL DATA",
      content:
        "<p class='faq__bloc-title'>Why create an account?</p> <br/> <p>Your account allows you to: manage your companies, manage your website, manage your web pages and manage your offers and invoices. All the information in your 1 Top Search account is only used for the purposes of your business relationship with 1 Top Search. This information is never shared with third parties or resold. It can be modified by you at any time through the management of your account area. It can also be completely deleted from our database on request.</p>",
    },
    fifth: {
      title: "HOW TO CONTACT US",
      content:
        "<p>For any resquest or question, you can directly contact us through our contact form on the website.</p>",
    },
  },

  legal: {
    title: "Legal mentions",
    subtitle: "Please find below our legal mentions.",
    bloc: {
      title: {
        first: "LEGAL INFORMATION",
        second: "INTELLECTUAL PROPERTY RIGHTS",
        third: "COOKIES",
      },
      first:
        "<p class='legal__bloc-subtitle'>Editor:</p><p>1 Top Search.</p> <p class='legal__bloc-subtitle'> Creation and referencing: </p> <p> Subforce, web agency based in Barcelone.<br/> Website : <a href='http://www.subforce.io/' target='_blank'>www.subforce.io</a><br/>Director of the publication: Mr. Antoine Jouve</p><p class='legal__bloc-subtitle'>Host: </p><p>Amazon Web Services Limited Liability Company (LLC) whose head office is located at P.O. Box 81226 Seattle, WA 98108-1226, USA</p><p class='legal__bloc-subtitle'> Copyright :</p><p></p>This entire site is subject to French and international legislation on copyright and intellectual property. All reproduction rights are reserved, including for photographic documents. The reproduction of all or part of this site on any electronic medium whatsoever is strictly forbidden without the express authorisation of the director of the publication. <p class='legal__bloc-subtitle'> Data processing and freedom: </p> The right to access, modify, rectify and delete data concerning you (article 34 of law 78-17 of 6 January 1978 relating to information technology, files and freedoms) can be exercised by contacting the Publication Director.",

      second:
        "<p>The website and all of its content (logos, graphic, textual and IT of the website, including in particular the structure, formatting, articles, presentations, illustrations, photographs, and/or any other document) are protected by the French and international legislation relating to intellectual property. All rights reserved copyright © – since 2022. <br/><br/> Under no circumstances may navigation on the website, or the mentions appearing on it, be interpreted as providing a user license or any right to use these elements. <br/><br/> In addition, their representations, reproductions, imbrications, diffusions and reruns, partial or total, are prohibited (article L. 122-4 of the French Intellectual Property Code). Any person proceeding to do so without being able to justify prior and express authorization from the holder of these rights is liable to penalties relating to the offense of counterfeiting (articles L. 335-2 and following of the French Intellectual Property Code). The Publisher may avail itself of its rights, in particular intellectual property rights, in order to take legal action, in particular under criminal law.<br/><br/>1 Top Search has the right to improve or modify at any time the information, products, programmes or conditions of use described in the website, without being held responsible for this. The conditions and mentions applicable shall be those in force on the date of your connection to the website.</p>",

      third:
        "<p>1 Top Search reserves the right to use cookies to give users the best experience on the website. Users are informed that during their visits to the <a href='http://www.1top-search.com' target='_blank'>www.1top-search.com</a> site, one or more cookies may be automatically installed on their browser software.</p><br><p>A cookie is a block of data that does not allow users to be identified but is used to record information related to the user's navigation on the site.</p><br><p>The configuration of the browser software makes it possible to inform of the presence of a cookie and to possibly refuse it.</p>",
    },
  },

  security: {
    title: "Privacy policy",
    subtitle: "Please find below our Privacy Policy.",
    content:
      "<p>This section is dedicated to our Privacy Policy. It enables you to find out more about the origin and use of the navigation information processed when you consult our website and about your rights. <br/><br/>The following information are communicated to you so that you can be aware of the commitments regarding the protection of personal data by 1 top Search which acts as data controller for the processing of personal data mentioned in this document.<br/><br/><br/><p class='privacy__content-title'>Personal data we proceed</p><br/>The processing of personal data and the data collected by 1 Top Search is not reused by any third party company or resold.<br/><br/>Our privacy policy is relevant to any user who shares personal data directly or indirectly on the Site in any way. <br/><br/>- The user has created an account on 1 Top Search (active mode) by declaring his professional identity.<br/><br/>- The visitor consults the 1 Top Search site (passive mode) to view professional information.<br/><br/><br/><p class='privacy__content-title'>Collected data</p><br/>All the information collected is visible from the different creation forms (personal account, company, websites, web page). <br/><br/>To create a 1 Top Search user account, you need to provide a first name, last name, email address and a password.<br/><br/>After creating your account, you will have access to a private, personal space that allows you to: manage your companies, manage your websites, manage your web pages and manage your offers and invoices.<br/><br/>Only publish personal data that you agree to make public.<br/><br/><br/><p class='privacy__content-title'>Data storage</p><br/>We keep your personal data as long as your user account is active, which means as long as it exists.<br/><br/>To delete your data, simply send an e-mail to the following address. To change or correct data, you can change the personal data yourself via the user area 1 Top Search.<br/><br/>If you have any questions about data protection, please contact us via our contact form.</p>",
  },

  cgv: {
    title: "General terms and conditions",
    subtitle: "Please find below our terms and conditions.",
    content:
      "<p><p class='privacy__content-title'>APPLICATION</p>The present general terms and conditions of sale are applicable to users of the site <a href='http://www.1top-search.com' target='_blank'>www.1top-search.com.</a><br/>Any use and payment validated on the site implies full and complete adherence to these general terms of sale. <p class='privacy__content-title'>GENERAL</p>The following terms “we”, “our” et “us” refer to 1 Top Search. We offer this website, including all information, tools and services available from it to users subject to acceptance of all of the following terms and conditions.<br/><br>By visiting this site and/or subscribing to our offerings, you are engaging in our “Service” and agree to be bound by the“Terms and conditions” including the additional terms and conditions referred to herein. These Terms and Conditions apply to all users who browse the site.<br/><br/>We reserve the right to update, change or replace any part of these Terms and Conditions on our website. It is your responsibility to check this page regularly for changes. Your continued use of or access to the website following the posting of any changes will constitute your acceptance of those changes.<p class='privacy__content-title'>GENERAL CONDITIONS</p>You agree not to reproduce, duplicate, copy, sell, resell or exploit any part of the Service or use of the Service, or any access to the Service or contact on the website through which the Service is provided, without our prior express written permission.<p class='privacy__content-title'>PRICE MODIFICATION</p>We reserve the right to change the price of the offers at any time, without prior notice. The offer will be invoiced to you on the basis of the rates in force at the time the offer is taken out. The offer is valid from the moment the payment has been accepted.<br/><p class='privacy__content-title'>OFFERS</p>All offer descriptions and prices are subject to change at any time without notice, at our sole discretion.<br/>We do not guarantee that the offer, services, or other information obtained or purchased by you will meet your expectations.<br/><p class='privacy__content-title'>ACCURACY OF BILLING AND ACCOUNT INFORMATION</p>You agree to provide current, complete and valid payment and account information for all payments made. You agree to promptly update your account information, including your email address, credit card numbers and expiration dates, so that we may complete your transactions and contact you if necessary.<p class='privacy__content-title'>OFFER DURATION</p>The offer is valid for a minimum of 1 year from the date of payment.<p class='privacy__content-title'>CANCELATION</p>These Terms and Conditions are effective until terminated. You may terminate these Terms and Conditions at any time by notifying us that you no longer wish to use our Services, or when you stop using our site.<br/><br/>The offer is tacitly renewable every year unless terminated at any time and at the latest on the date of expiry of the offer, which is indicated in the « User account » in « Manage company».<br><br>Any cancellation must be notified via the « Unsubscribe » button accessible in « My acount ».<br><br>The cancellation will take effect after the expiry date of the current offer.<br><br>We have the right to terminate and/or suspend access to our offers as of right in the following cases: <br>- in the event of non-payment by the Customer of the payment(s) due under the offer.<br>- in the event that the information communicated by the user in the context of the subscription to the offer is incomplete, inaccurate, invalid or obsolete.<br><br>Such termination/suspension will result in the immediate deactivation of the offer on our site without any right to compensation or refund. The user will be notified of this decision.<p class='privacy__content-title'>PRICE AND PAYMENT TERMS</p>The offer implies the payment by the user of a fixed annual price communicated to the user prior to the subscription of the offer. The prices are indicated inclusive of all taxes at the rate in force on the day of the subscription.<br><br>Any change to the annual flat rate price referred to in this article shall be brought to the attention of the user at least one month before it comes into force. In this case, the user shall have the option of cancelling the offer without charge, under the conditions set out above.<br><br>The user acknowledges and accepts that, by communicating his bank card details, he authorizes 1 Top Search to debit his bank card at the time of the annual renewal of his offer.<p class='privacy__content-title'>APPLICABLE LAW</p>These General Terms and Conditions of Sale are governed by and construed in accordance with French laws.<p class='privacy__content-title'>DISPUTE</p>The applicable law is French law. In the event of a dispute, the French courts shall have exclusive jurisdiction.</p>",
  },
  cookies: {
    text: "We use cookies on our website in order to provide you with a personalized and optimized experience.",
    btn: " More information.",
  },

  addUserModal: {
    title: "Add user to company",
    label: "User email",
    confirm: "User correctly added",
    addMore: "Add more user",
  },

  metadata: {
    home: {
      title:
        "1 Top Search: the directory of professionals websites | 1 Top Search",
      description:
        "1 Top Search: professional website directory to improve the visibility of businesses online. Find companies from various sectors with the online directory.",
    },
    categories: {
      title:
        "Categories: professional sectors | business directory 1 Top Search",
      description:
        "Search for a business website by category. Find business websites from different sectors from technology, finance to online shop by searching the online directory.",
    },
    offers: {
      title:
        "Our offers to gain online visibility | business directory 1 Top Search",
      description:
        "Offers adapted to your needs: free registration, company or agency pack, personalized offers to benefit from more online visibility thanks to the online directory.",
    },
    about: {
      title: "About 1 Top Search, the online business directory | 1 Top Search",
      description:
        "Learn more about the online business directory. Why register your company and website on 1 Top Search? What are the advantages? What is the aim of 1 Top Search?",
    },
    aboutWebsite: {
      title: "{#name} - about: websites y pages | directory 1 Top Search",
    },
    register: {
      title:
        "Registration: register and manage companies and websites | 1 Top Search",
      description:
        "Create an account, register your company, websites and web pages on the 1 Top Search business directory. Subscribe to offers and manage your information.",
    },
    login: {
      title: "Login: log in to your personal account | directory 1 Top Search",
      description:
        "Log in to your account to manage your companies, websites, web pages, manage your offers, edit your personal information, change your password...",
    },
    account: {
      title:
        "My account: manage your account and add companies | directory 1 Top Search",
      description:
        "Manage your account: edit your information, manage your companies, add a new company, add websites and pages from your account.",
    },
    contact: {
      title: "Contact: contact us through the form | 1 Top Search",
      description:
        "To contact us, please fill in the contact form directly on our 1 Top Search website. Our team is available to answer all your questions about our online business directory.",
    },
    faq: {
      title:
        "Frequently Asked Questions: we answer your questions | 1 Top Search",
      description:
        "We answer all your questions: what is 1 Top Search? Why register your company and websites in the directory? Our offers, advantages, payment...",
    },
    resetPassword: {
      title: "Reset your password | online business directory 1 Top Search",
      description:
        "Forgot your password ? Reset your password and create a new one. Enter your email then click on the link we sent you to reset your password.",
    },
    orderSummary: {
      title:
        "Your order summary, offers | online business directory 1 Top Search",
      description:
        "Find the details of your order with the offers and options you have subscribed to as well as the quantity and price. Then confirm your order.",
    },
    paymentConfirmation: {
      title: "Paiement confirmation | online business directory 1 Top Search",
      description:
        "We confirm that your paiement has been done with success. You can now enjoy your offer and options and start adding your company, websites and pages on our business directory.",
    },
  },
};
